<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>Web Developer</h2>
    <p>
      You know that feeling when you dive into something you love and you look up hours later and realize you forgot to eat? That's how I feel about code.
      <br/>
      {fwiw, I rather enjoy eating}
    </p>
    <h3>Knowledge:</h3>
    <ul>
      <li class="item-list" v-for="(known, key) in knowns" :key="key">{{ known }}</li>
    </ul>
    <h3>Tinker with:</h3>
    <ul>
      <li class="item-list" v-for="(tinker, key) in tinkers" :key="key">{{ tinker }}</li>
      <br/>{And just for fun I made this site with Vue/Vue-router/Netlify}
    </ul>

    <h3>Shipped code lives on these (most recent first):</h3>
    <ul>
      <li><a href="//www.refersion.com" target="_blank" rel="noopener">Refersion</a></li>
      <li><a href="//www.ritani.com" target="_blank" rel="noopener">Ritani</a></li>
      <li><a href="//www.firstfitmgt.com" target="_blank" rel="noopener">First Fitness Mgt</a></li>
      <li><a href="//www.warrioricearena.com/" target="_blank" rel="noopener">Warrior Ice Arena</a></li>
      <li><a href="//www.lyricgroup.com/.com" target="_blank" rel="noopener">Lyric Group</a></li>
    </ul>
    <h3>Personal:</h3>
    <ul>
      <li><a href="//www.github.com/mare1601" target="_blank" rel="noopener">Github</a></li>
      <li><a href="//www.twitter.com/maryellis" target="_blank" rel="noopener">Twitter</a></li>
      <li><a href="//www.littlest-fish.com" target="_blank" rel="noopener">Old Portfolio</a></li>
      <li><a href="//www.getbankorbust.com/about" target="_blank" rel="noopener">Bank or Bust - beta</a></li>
      <li><a href="//react-weather-mellis.netlify.app/" target="_blank" rel="noopener">React Weather Practice on Netlify w/ OpenWeatherMap.org API</a></li>
      <li><a href="//angularlistmare1601.herokuapp.com/" target="_blank" rel="noopener">Angular TODO Practice on Heroku w/ mLab</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Main',
  props: {
    msg: String,
  },
  data(){
    return {
      knowns:  ['Reactjs', 'HTML5', 'CSS3', 'SCSS', 'Prettier', 'Javascript', 'jQuery', 'Git', 'Github', 'PHP', 'Laravel', 'mLab', 'Netlify', 'APIs', 'Wordpress', 'Heroku'],
      tinkers: ['Webpack', 'Babel', 'eslint', 'Jest', 'SQL', 'Python/Django', 'Redux', 'node.js', 'CircleCI', 'Angular']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin: 40px 0 0;
}
h2 {
  margin: 10px 0 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.item-list {
  background-color: #e3e3e3;
  padding: 2px 5px;
  margin: 2px;
  border-radius: 3px;
}
</style>
